var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSynchronize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 11.0003C4.49984 9.75959 4.88436 8.54932 5.60061 7.53618C6.31686 6.52305 7.3296 5.7569 8.49935 5.34325C9.66911 4.92959 10.9383 4.88878 12.1323 5.22643C13.3262 5.56408 14.386 6.26358 15.1659 7.2286",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.499 5.00073V7.66721H12.8325M16.4989 11.0003C16.4989 12.241 16.1143 13.4512 15.398 14.4642C14.6817 15.4772 13.669 16.2433 12.4992 16.6568C11.3295 17.0704 10.0603 17.1112 8.86649 16.7735C7.67263 16.4358 6.61283 15.7363 5.83301 14.7714",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 16.9998V14.3334H8.16648",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSynchronize);
export default __webpack_public_path__ + "static/media/synchronize.f8cac69201299a32943392d83de02e53.svg";
export { ForwardRef as ReactComponent };